<template>
	<b-nav-item-dropdown right no-caret>
		<template slot="button-content">
			<div v-if="user.photoURL === null || user.photoURL === ''" class="avatar_hrs avatar-bg">{{ user.display_name | short_name}}</div>
			<img v-else :src="user.photoURL" class="img-avatar" :alt="user.email">
		</template>
		<b-dropdown-header tag="div" class="text-center"><strong>{{ user.display_name }}</strong></b-dropdown-header>
		<b-dropdown-item><i class="fa fa-envelope-o"></i> Obvestila<b-badge variant="success">{{itemsCount}}</b-badge></b-dropdown-item>
		<!--b-dropdown-item><i class="fa fa-tasks"></i> Aktivnosti<b-badge variant="danger">{{itemsCount}}</b-badge></b-dropdown-item-->
		<!--b-dropdown-header tag="div" class="text-center"><strong>Nastavitve</strong></b-dropdown-header-->
		<b-dropdown-item to="/profile"><i class="fa fa-user"></i> Profil</b-dropdown-item>
		<!--b-dropdown-item><i class="fa fa-wrench"></i> Nastavitve</b-dropdown-item-->
		<b-dropdown-item @click="logOut"><i class="fa fa-lock"></i> Odjava</b-dropdown-item>
	</b-nav-item-dropdown>
</template>
<style>
	.avatar_hrs {
		width: 35px;
		height: 35px;
		margin: 0 10px;
		border-radius: 50%;
		line-height: 34px;
		font-size: 1rem;
		overflow: hidden;
	}
</style>
<script>
import firebase from 'firebase'

export default {
	name: 'header-dropdown',
	data: () => {
		return {
			itemsCount: 42
		}
	},
	filters: {
	},
	methods: {
		logOut: function (event) {
			firebase.auth().signOut()
				.then(() => {
					this.$store.dispatch('clearUser');
					this.$router.replace('/auth/login');
				})
				.catch(error => {
					console.log('logout error: ');
					console.log(error);
				});
		}
	},
	computed: {
		user () {
			return this.$store.getters.user;
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/Header/HeaderDropdown.vue